module.exports = __webpack_public_path__ + "img/unlink_item_icon.22ae825b.svg";